var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui button no border",class:[
        {
            'loading': _vm.is_processing,
        },
        _vm.active_button_color || 'blue'
    ],on:{"click":function($event){_vm.action_core_waybill()}}},[_vm._v("\n    "+_vm._s(_vm.active_button_content || _vm.$t('ui.general.update'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }